import React from 'react';
import PropTypes from 'prop-types';
import './EtchSubHeroModule.scss';

const EtchSubHeroModule = (props) => {
  const opts = props?.opts;
  const {
    heading,
    ctaLink,
    subHeading,
    heroMedia,
    heroMediaMobile,
    cta
  } = opts;

  const Picture = () => {
    return (
      <picture className="subHero__media">
        <source media="(min-width: 640px)" srcSet={heroMedia?.src} />
        {
          heroMediaMobile?.src
          && <source media="(min-width: 0px)" srcSet={heroMediaMobile?.src} />
        }
        {
          !heroMediaMobile && heroMedia?.src
          && <source media="(min-width: 0px)" srcSet={heroMedia?.src} />
        }
        <img
          className="stretchy subHero__main"
          src={heroMedia?.src}
          alt={heroMedia?.alt}
        />
      </picture>
    );
  };

  const SubHeroInfo = () => {
    return (
      <div className="subHero__info u__text-shadow--none">
        <h2 className="subHero__heading u__display-font--black u__jumbo">
          {heading}
        </h2>
        {
          subHeading
          && <h3 className="subHero__subHeading u__large">{subHeading}</h3>

        }
        {
          cta && (
            <button className="subHero__btn bttn bttn--primary bttn--inline">
              <span className="subHero__btn__content bttn__content">{cta}</span>
            </button>
          )
        }
      </div>
    );
  };

  return (
    <div className="subHero etch-analytics">
      {
        ctaLink && (
          <a className="subHero__link" href={ctaLink}>
            {Picture()}
          </a>
        )
      }
      {!ctaLink && Picture()}
      {
        ctaLink
        && (
          <a href={ctaLink}>
            {SubHeroInfo()}
          </a>
        )
      }

    </div>
  );
};

EtchSubHeroModule.displayName = 'EtchSubHeroModule';

EtchSubHeroModule.propTypes = {
  opts: PropTypes.shape({
    heading: PropTypes.string,
    cta: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    subHeading: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    ctaLink: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    heroMedia: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    }),
    heroMediaMobile: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    }),
  })
};

EtchSubHeroModule.defaultProps = {
  opts: {}
};

export default EtchSubHeroModule;
